import React from 'react';
import { Image } from 'semantic-ui-react';
import { getIcon } from './PaymentMethodIcon.utils';
import './PaymentMethodIcon.css';
var defaultProps = {};
function PaymentMethodIcon(_ref) {
  var type = _ref.type;
  var Icon = getIcon(type);
  if (!Icon) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Image, {
    className: "payment-method-icon",
    src: Icon
  });
}
PaymentMethodIcon.defaultProps = defaultProps;
export default PaymentMethodIcon;